var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "12", height: "15" }, props),
    React.createElement("path", { d: "M4.752.466C4.974.182 5.321 0 5.714 0a1.215 1.215 0 0 1 .91.409l4.36 4.841a1.206 1.206 0 0 1-.099 1.707 1.213 1.213 0 0 1-1.708-.081L6.93 4.379v8.818c0 .664-.54 1.203-1.215 1.203A1.214 1.214 0 0 1 4.5 13.197V4.379L2.25 6.876c-.44.49-1.209.53-1.708.08A1.206 1.206 0 0 1 .445 5.25L4.752.466z", fill: "#969EA2" })
  );
});